import React from 'react';
import { PartnerExaminationPageLayout } from 'pages/Partner/PartnerExaminationPage/components/PartnerExaminationPageLayout';
import {
  ExaminationPageHeader,
  ExaminationPageInfoBarSkeleton,
  ExaminationPageOverviewSkeleton,
  ExaminationPageInfoBarOuterContainer,
} from '@higo/common/lib/features/ExaminationPage/components';

export const PartnerExaminationPageSkeleton = () => (
  <ExaminationPageHeader shadowless>
    <PartnerExaminationPageLayout>
      <ExaminationPageOverviewSkeleton />
    </PartnerExaminationPageLayout>
    <ExaminationPageInfoBarOuterContainer>
      <PartnerExaminationPageLayout>
        <ExaminationPageInfoBarSkeleton />
      </PartnerExaminationPageLayout>
    </ExaminationPageInfoBarOuterContainer>
  </ExaminationPageHeader>
);
